import {useEffect} from "react";
import {useParams} from "react-router-dom";
import ApiService from "../core/service/ApiService";

export default function PatientDownload({}) {
    const {token, name, reportId} = useParams()

    useEffect(() => {
        const _token = decodeURIComponent(escape(window.atob(token)))
        const _name = decodeURIComponent(escape(window.atob(name)))
        const link = ApiService.PatientApp.GetDicomZipRealLink(reportId, _name, _token)
        const a = document.createElement('a');
        a.href = link;
        a.download = `${_name}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }, []);

    return (
        <div>
            <h1>Indirme isleminiz basladi.</h1>
        </div>
    )
}